import {
  Component,
  OnInit,
  OnDestroy,
  NgZone,
  EventEmitter,
  Input,
  ViewChild,
} from "@angular/core";
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from "@angular/cdk/drag-drop";
import { ModalDirective } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import {
  AuthorizationService,
  ModelService,
  PoweredByService,
  EquipmentService,
  AssociationService,
  Model,
  PoweredBy,
  Equipment,
  PoweredBysByModel,
  EquipmentForModelAndPoweredBy,
  DocumentService,
  Document,
  EquipmentDocuments,
  GlobalService,
  DeleteConfirmation,
  ToastrService,
} from "./../../../../shared/index";

@Component({
  selector: "equipment-entity",
  templateUrl: "./equipment-entity.html",
  standalone: false,
})
export class EquipmentEntityComponent implements OnInit, OnDestroy {
  @Input("equipment") equipment: Equipment = new Equipment();
  @Input("model") model: Model = new Model();
  @Input("poweredby") poweredby: PoweredBy = new PoweredBy();
  @Input("simplified") simplified = false;
  @Input("full") full = false;
  @Input("forDocuments") forDocuments = false;
  //@Input("isDocumentPage") isDocumentPage: boolean;
  //@Input("Is_Published") Is_Published: boolean = true;
  //@Input("Is_Project_Selected") Is_Project_Selected: boolean = false;//TJC 10-27-20 need to know if project is selected
  @Input("live") live = true;
  private subscriptions: Subscription[] = [];
  @ViewChild("DeleteEquipment") ModelDeleteEquipment: ModalDirective;

  public documents: Document[] = [];
  public documentsShown = false;
  public processing = false;
  public isDocumentPage = false;

  constructor(
    private _ngZone: NgZone,
    private _equipmentService: EquipmentService,
    private _poweredByService: PoweredByService,
    private _documentService: DocumentService,
    private _associationService: AssociationService,
    private _globalService: GlobalService,
    private _toastrService: ToastrService
  ) {}

  public details(): void {
    if (this.forDocuments) {
    } else {
      this._equipmentService.showDetails(this.equipment);
    }
  }

  public transferDataSuccess($event: any): void {
    const docIds: number[] = [];
    for (const doc of $event.previousContainer.data.Data) {
      docIds.push(doc.Id);
    }
    this._associationService.associateDocumentsToEquipment(
      this.equipment.Id,
      docIds
    );
  }

  public getDocuments(): void {
    if (!this.documentsShown) {
      this.processing = true;
      this._documentService.getEquipmentDocuments(this.equipment.Id);
    }
    this.documentsShown = !this.documentsShown;
  }

  public edit(): void {
    if (Number(localStorage.getItem("Lock")) == 1) {
      this._toastrService.displayToastrMessage(
        "error",
        localStorage.getItem("Msg"),
        "Environment Status!"
      );
      return;
    }
    this._equipmentService.manipulate(this.equipment);
  }
  public delete(): void {
    if (Number(localStorage.getItem("Lock")) == 1) {
      this._toastrService.displayToastrMessage(
        "error",
        localStorage.getItem("Msg"),
        "Environment Status!"
      );
      return;
    }
    this.ModelDeleteEquipment.show();
    //this._globalService.confirmDelete("equipment", this.equipment.Serial, this.equipment.Equipment_ID);
  }
  public removeAssociation(): void {
    if (Number(localStorage.getItem("Lock")) == 1) {
      this._toastrService.displayToastrMessage(
        "error",
        localStorage.getItem("Msg"),
        "Environment Status!"
      );
      return;
    }
    this._equipmentService.removeAssociation(this.equipment.Equipment_ID);
  }
  public showRecommended(): void {
    this._equipmentService.showRecommendedDocuments(this.equipment);
  }
  public removeDocument(documentId: number): void {
    if (Number(localStorage.getItem("Lock")) == 1) {
      this._toastrService.displayToastrMessage(
        "error",
        localStorage.getItem("Msg"),
        "Environment Status!"
      );
      return;
    }
    this._associationService.removeDocumentAssociations(this.equipment.Id, [
      documentId,
    ]);
  }
  ngOnInit(): void {
    if (this.forDocuments) {
      this.subscriptions.push(
        this._associationService.documentsAssociated.subscribe(
          (result: boolean) => {
            this._documentService
              .getDocumentCountForEquipment(this.equipment.Id)
              .then((result) => {
                this.equipment.DocumentCount = result;
              });
          }
        )
      );

      this.subscriptions.push(
        this._documentService.equipmentDocumentChange.subscribe(
          (info: EquipmentDocuments) => {
            if (this.equipment.Id == info.EquipmentId) {
              this._ngZone.run(() => {
                this.documents = info.Documents;
                this.processing = false;
              });
            }
            this._documentService
              .getDocumentCountForEquipment(this.equipment.Id)
              .then((result) => {
                this.equipment.DocumentCount = result;
              });
          }
        )
      );
      this._documentService
        .getDocumentCountForEquipment(this.equipment.Id)
        .then((result) => {
          this.equipment.DocumentCount = result;
        });
    } else {
      //this.subscriptions.push(this._globalService.deleteResultEx.subscribe((result: DeleteConfirmation) => {
      //    if (result.Confirmed && result.EntityType == "equipment" && result.EntityId == this.equipment.Equipment_ID) {
      //        this._equipmentService.delete(this.equipment);
      //    }
      //}));
    }
    const docFlag = JSON.parse(localStorage.getItem("docFlag"));
    if (docFlag) {
      this.isDocumentPage = docFlag;
    }
  }
  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }
  DeleteSelectedEquipment() {
    this.ModelDeleteEquipment.hide();
    this._equipmentService.delete(this.equipment);
  }
  Close(): void {
    this.ModelDeleteEquipment.hide();
  }
}
